const log = process.env.NODE_ENV === 'production' ? function () {} : console.log.bind(console)

const gameButtonClickedPrefix = 'game.button.clicked.'
module.exports = (cxf = window.CXF) => {
  return {
    // @todo STP-404 separate logic of CXF event from window methods
    ggsGameInitialized() {
      window.giDispatcher('CXFregisterServerCommands', cxf.eventNames().filter(e => !e.startsWith(gameButtonClickedPrefix)))
    },
    onServerCommandReceived(...args) {
      // Flash and html are sending data in the same way
      // ExternalInterface.call("onServerCommandReceived", [msgName, message, (<any>window).ggs.worldAssignment.facade.currentCountry.ggsLanguageCode, network, (<any>window).ggs.worldAssignment.facade.selectedNetworkInstance.instanceId])
      // but for some reason gameMessagehandler wraps all params into additional array..
      //
      // @todo let’s seriously investigate the behaviour desribed above

      let response = args.length === 1 && Array.isArray(args[0]) ? args[0] : args
      response = response.length === 1 && Array.isArray(response[0]) ? response[0] : response

      const [msgName, ...others] = response
      log('COMMAND: ', msgName, ' params: ', others)
      cxf.emit(msgName, others)
    },

    // PoC of CXF reacting to UI interaction from game
    UIButtonClicked(param) {
      const [btnName, ...payload] = param
      log(gameButtonClickedPrefix, btnName)

      try {
        cxf.emit(gameButtonClickedPrefix + btnName, ...payload)
      } catch (error) {
        console.error('cant dispatch CXF.UI.clicked event')
      }
    },

    playDropPelletsAnimation(itemIdOrArray, amount) {
      if (Array.isArray(itemIdOrArray) && arguments.length > 1) {
        console.warn('Call either playDropPelletsAnimation([[wodId, amount], ...]) or playDropPelletsAnimation(wodId, amount)')
        return
      }

      if (typeof window.playDropPelletsAnimation !== 'function') {
        return
      }

      const items = Array.isArray(itemIdOrArray) ?
        itemIdOrArray :
        [[itemIdOrArray, amount]]

      items.forEach(([wodId, amount]) => window.playDropPelletsAnimation(wodId, amount))
    }
  }
}
